<ridango-single-ticket
    *ngIf="type === 'SINGLE'"
    [actions]="actions"
    [useInputActions]="useInputActions"
    [ticket]="ticket"
    [locale]="locale"
    (requestDisplayQR)="qr($event)"
    (requestDeleteTicket)="delete($event)"
    (requestRemoveCard)="removeCard($event)"
    (requestTicketAction)="ticketAction($event)">
</ridango-single-ticket>

<ridango-wallet-ticket
    *ngIf="type === 'WALLET'"
    [actions]="actions"
    [useInputActions]="useInputActions"
    [ticket]="ticket"
    [locale]="locale"
    (requestDisplayQR)="qr($event)"
    (requestDeleteTicket)="delete($event)"
    (requestRemoveCard)="removeCard($event)"
    (requestTicketAction)="ticketAction($event)">
</ridango-wallet-ticket>

<ridango-period-ticket
    #periodTicket
    *ngIf="type === 'PERIOD'"
    [actions]="actions"
    [useInputActions]="useInputActions"
    [ticket]="ticket"
    [locale]="locale"
    [showActionDropdownAlways]="showActionDropdownAlways"
    [transportDayEndPrevDate]="transportDayEndPrevDate"
    [showValidityDayName]="showValidityDayName"
    [useActiveValidationText]="useActiveValidationText"
    [showValidityStart]="showValidityStart"
    [hasZoneModal]="hasZoneModal"
    [cards]="cards"
    [ticketsByDocNums]="ticketsByDocNums"
    [canDeleteFromCart]="canDeleteFromCart"
    (requestDisplayQR)="qr($event)"
    (requestDeleteTicket)="delete($event)"
    (requestRemoveCard)="removeCard($event)"
    (requestTicketAction)="ticketAction($event)"
    (requestPauseTicket)="pause($event)"
    (requestReactivateTicket)="reactivate($event)"
    (requestRenewTicket)="renew($event)"
    (requestShowZoneModal)="showZoneModal()">
</ridango-period-ticket>

<ridango-hours-ticket
    #periodTicket
    *ngIf="type === 'HOURS'"
    [actions]="actions"
    [useInputActions]="useInputActions"
    [ticket]="ticket"
    [locale]="locale"
    [showActionDropdownAlways]="showActionDropdownAlways"
    [transportDayEndPrevDate]="transportDayEndPrevDate"
    (requestDisplayQR)="qr($event)"
    (requestDeleteTicket)="delete($event)"
    (requestRemoveCard)="removeCard($event)"
    (requestTicketAction)="ticketAction($event)"
    (requestPauseTicket)="pause($event)"
    (requestReactivateTicket)="reactivate($event)"
    (requestRenewTicket)="renew($event)"
    (requestShowZoneModal)="showZoneModal()">
</ridango-hours-ticket>

<ng-template #deleteConfirmation>
    <ridango-dialog [size]="'460'" [visible]="true" (onClose)="closeModal()">
        <h1 class="dialog-title bold" *ngIf="context !== 'cart'">
            {{ 'SHOPPING_CART_DELETE_TICKET_MODAL_TITLE' | translate }}
        </h1>

        <h1 class="dialog-title bold" *ngIf="context === 'cart'">
            {{ 'SHOPPING_CART_DELETE_CART_MODAL_TITLE' | translate }}
        </h1>

        <!-- <button class="modal-dialog__btn-close"  (click)="closeModal()">
            <span class="icon icon-input-delete"></span>
        </button> -->

        <div class="dialog-description">
            <p *ngIf="context !== 'cart'">
                {{ 'SHOPPING_CART_DELETE_TICKET_MODAL_TEXT' | translate }}
            </p>
            <p *ngIf="context === 'cart'">
                {{ 'SHOPPING_CART_DELETE_CART_MODAL_TEXT' | translate }}
            </p>
        </div>

        <div class="dialog-buttons-area">
            <div class="dialog-buttons-area__right">
                <button
                    class="btn btn--big btn--primary btn--maximal"
                    (click)="deleteTicket()"
                    (keydown.space)="deleteTicket()"
                    (keydown.enter)="deleteTicket()"
                    tabindex="0">
                    {{ 'SHOPPING_CART_DELETE_MODAL_BTN_YES_DELETE' | translate }}
                </button>
            </div>

            <div class="dialog-buttons-area__left">
                <a
                    class="link link--emphasized link--action"
                    #deleteModalFocus
                    (click)="closeModal()"
                    (keydown.space)="closeModal()"
                    (keydown.enter)="closeModal()"
                    tabindex="0"
                    >{{ 'SHOPPING_CART_DELETE_MODAL_CANCEL' | translate }}</a
                >
            </div>
        </div>
    </ridango-dialog>
</ng-template>

<ng-template #pauseModal>
    <ridango-modal
        *ngIf="ticket.pause_count > 0"
        [size]="'460'"
        [isItSmall]="true"
        [visible]="true"
        [visibleCloseIcon]="false">
        <div class="info-summary">
            <h1>
                {{ 'PAUSE_TICKET_MODAL_TITLE' | translate }}
            </h1>

            <p>
                {{ 'PAUSE_TICKET_MODAL_DESCRIPTION' | translate }}
            </p>

            <ul class="diferent-bullets block" innerHtml="{{ 'PAUSE_TICKET_MODAL_INFO' | translate }}"></ul>

            <p>
                {{ 'PAUSE_TICKET_MODAL_CONFIRMATION_TEXT' | translate }}
            </p>

            <button
                class="btn btn--big btn--primary btn--maximal margin-bottom-20"
                (click)="pause()"
                (keydown.enter)="pause()"
                (keydown.space)="pause()"
                tabindex="0">
                {{ 'PAUSE_TICKET_MODAL_BUTTON' | translate }}
            </button>

            <div class="align-center">
                <a
                    class="link link--emphasized link--action modal-dialog__cancel-link"
                    #pauseModalFocus
                    (click)="closePauseModal()"
                    (keydown.enter)="closePauseModal()"
                    (keydown.space)="closePauseModal()"
                    tabindex="0"
                    >{{ 'PAUSE_TICKET_MODAL_CANCEL' | translate }}</a
                >
            </div>
        </div>
    </ridango-modal>

    <ridango-dialog *ngIf="ticket.pause_count === 0" [size]="'460'" [visible]="true">
        <div class="dialog-description">
            <p>
                {{ 'NO_TICKET_PAUSES_LEFT' | translate }}
            </p>
        </div>

        <div class="dialog-buttons-area">
            <div class="dialog-buttons-area__right">
                <button
                    class="btn btn--big btn--primary btn--maximal"
                    (click)="closePauseModal()"
                    (keydown.enter)="closePauseModal()"
                    (keydown.space)="closePauseModal()">
                    {{ 'DIALOG_BUTTON_OK' | translate }}
                </button>
            </div>
        </div>
    </ridango-dialog>
</ng-template>

<ng-template #qrModal>
    <ridango-modal #qrModalEl [size]="'460'" [visible]="true" (onCloseModal)="closeQrModal()">
        <div class="qr-code">
            <div class="qr-code-area">
                <h1 class="title" cdkFocusInitial>{{ 'MODAL_VOUCHER_TITLE' | translate }}</h1>
                <div class="qr-code__middle">
                    {{ 'MODAL_VOUCHER_DESCRIPTION' | translate }}
                </div>
                <div class="qr-code__bottom">
                    <div class="qr-img">
                        <qrcode [qrdata]="ticket?.card_id" [size]="200" [level]="'M'"></qrcode>
                    </div>
                </div>
            </div>
        </div>
    </ridango-modal>
</ng-template>

<ng-template #zoneModal>
    <ridango-modal #modal [size]="'800'" [visible]="true" [isItSmall]="true" (onCloseModal)="closeZoneModal()">
        <div class="all-areas-and-stops">
            <div class="all-areas-and-stops-area">
                <h1 class="title">{{ 'AREA_INFO_MODAL_TITLE' | translate }}</h1>

                <p>{{ 'AREA_INFO_MODAL_DESCRIPTION' | translate }}</p>

                <img
                    class="zones-map"
                    src="{{ assetsPath }}/map_details.png"
                    alt="{{ 'ZONE_MAP_IMG_ALT' | translate }}" />
            </div>
        </div>
    </ridango-modal>
</ng-template>
